module.exports = __webpack_public_path__ + "static/grundriss_mobilitat_mini-d1894b5f8b8cc784c31bb369f3a874fb.png";